/*
Adding a view to the router:
  1. Import view from the views folder
  2. Add view to the routes array
  3. Add properties for each route 
*/

import { createRouter, createWebHistory } from 'vue-router'
import StartView from '@/views/StartView.vue'
import SelectServiceView from '@/views/SelectServiceView.vue'
import ChooseLangView from '@/views/ChooseLangView.vue'


// help/
import HelpCenterView from '@/views/help/HelpCenterView.vue'
import PrivacyPolicyView from '@/views/help/PrivacyPolicyView.vue'
import EndUserAgreementView from '@/views/help/EndUserAgreementView.vue'
import ContactSupportView from '@/views/help/ContactSupportView.vue'

// services/
import ServicesMenuView from '@/views/services/ServicesMenuView.vue'
import BalanceInquiryMenuView from '@/views/services/BalanceInquiryMenuView.vue'
import MembershipInfoView from '@/views/services/MembershipInfoView.vue'

// services/balance-inquiry/
import LedgersMenuView from '@/views/services/ledgers/LedgersMenuView.vue'
import TransactionsLedgerView from '@/views/services/ledgers/TransactionsLedgerView.vue'

// login/
import KioskLoginView from '@/views/login/KioskLoginView.vue'
import LoginMenuView from '@/views/login/LoginMenuView.vue'
import EnterPINView from '@/views/login/EnterPINView.vue'
import ScanQRView from '@/views/login/ScanQRView.vue'
import PAPSIMobileLoginView from '@/views/login/PAPSIMobileLoginView.vue'
import AccountSerialNumberLoginView from '@/views/login/AccountSerialNumberLoginView.vue'
import EnrollPINView from '@/views/login/EnrollPINView.vue'
import EditTemporaryPINView from '@/views/login/EditTemporaryPINView.vue'

// error/
import ErrorSection from '@/components/sections/ErrorSection.vue'
import store from '@/store';


const routes = [
  {
    path: "/error",
    name: "error",
    component: ErrorSection,
    meta: {
      title: 'Error Page'
    }
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/error"
  },
  {
    path: '/services/balance-inquiry/ledger/:type/:code',
    component: TransactionsLedgerView,
    name: 'transactions-page',
    meta: {
      title: 'Transactions Ledger'
    }
  },
  {
    path: '/services/balance-inquiry/:type',
    component: LedgersMenuView,
    name: 'accounts-menu-page',
    meta: {
      title: 'Accounts Menu Page'
    }
  },
  {
    path: '/login/kiosk',
    name: 'kiosk-login-page',
    component: KioskLoginView,
    meta: {
      title: 'Kiosk Login'
    }
  },
  {
    path: '/',
    name: 'start-page',
    component: StartView,
    meta: {
      title: 'PAFCPIC Information Kiosk'
    }
  },
  {
    path: '/select',
    name: 'selection-page',
    component: SelectServiceView,
    meta: {
      title: 'Select Service'
    }
  },
  {
    path: '/choose-lang',
    name: 'choose-lang-page',
    component: ChooseLangView,
    meta: {
      title: 'Choose Language'
    }
  },
  {
    path: '/help/end-user-license-agreement',
    name: 'end-user-license-agreement',
    component: EndUserAgreementView,
    meta: {
      title: 'End-User License Agreement'
    }
  },
  {
    path: '/help/privacy-policy',
    name: 'privacy-policy-page',
    component: PrivacyPolicyView,
    meta: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '/help/contact-support',
    name: 'contact-support-page',
    component: ContactSupportView,
    meta: {
      title: 'Contact Support'
    }
  },
  {
    path: '/help',
    name: 'help-center-page',
    component: HelpCenterView,
    meta: {
      title: 'Help Center'
    }
  },
  {
    path: '/login',
    name: 'login-page',
    component: LoginMenuView,
    meta: {
      title: 'User Login'
    }
  },
  {
    path: '/login/enter-pin',
    name: 'enter-pin-page',
    component: EnterPINView,
    meta: {
      title: 'Enter PIN'
    }
  },
  {
    path: '/login/papsi-mobile',
    name: 'papsi-mobile-login-page',
    component: PAPSIMobileLoginView,
    meta: {
      title: 'PAPSI Mobile Login'
    }
  },
  {
    path: '/login/account-serial-number',
    name: 'account-serial-numberlogin-page',
    component: AccountSerialNumberLoginView,
    meta: {
      title: 'Account Serial Number Login'
    }
  },
  {
    path: '/login/enroll-pin',
    name: 'enroll-pin-page',
    component: EnrollPINView,
    meta: {
      title: 'Enroll PIN'
    }
  },
  {
    path: '/login/edit-pin',
    name: 'edit-pin-page',
    component: EditTemporaryPINView,
    meta: {
      title: 'Edit PIN'
    }
  },
  {
    path: '/login/scan-qr',
    name: 'scan-qr-page',
    component: ScanQRView,
    meta: {
      title: 'Scan QR Code'
    }
  },
  {
    path: '/services/view-member-info',
    name: 'member-info-page',
    component: MembershipInfoView,
    meta: {
      title: 'Membership Information'
    }
  },
  {
    path: '/services',
    name: 'services-page',
    component: ServicesMenuView,
    meta: {
      title: 'Services Menu'
    }
  },
  {
    path: '/services/balance-inquiry',
    name: 'balance-inquiry-page',
    component: BalanceInquiryMenuView,
    meta: {
      title: 'Balance Inquiry Menu'
    }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  const device_id = store.state.branch.device_id; 

  if (!to.query.device_id && device_id) {
    next({
      path: to.path,
      query: { ...to.query, device_id: device_id },
    });
  } else {
    next();
  }
});


export default router